// extracted by mini-css-extract-plugin
export default {"input":"B8-z","button":"C8-z","selected":"D8-z","unavailable":"E8-z","oos":"F8-z","image":"G8-z","paperCutDisabledOverlay":"H8-z"};